import { useRef, useState } from "react";
import api, { errMsg, imgUrl } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ImagePlus, X, Loader2 } from "lucide-react";

export default function ImageUpload({ value, onChange, testid = "image-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) return toast.error("Veuillez choisir une image");
    if (file.size > 5 * 1024 * 1024) return toast.error("Image trop volumineuse (max 5 Mo)");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.path);
      toast.success("Photo ajoutée");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-4" data-testid={testid}>
      <div className="w-24 h-24 rounded-xl border border-border bg-background overflow-hidden flex items-center justify-center shrink-0">
        {busy ? (
          <Loader2 className="w-6 h-6 text-muted-foreground animate-spin" />
        ) : value ? (
          <img src={imgUrl(value)} alt="Aperçu" className="w-full h-full object-cover" data-testid={`${testid}-preview`} />
        ) : (
          <ImagePlus className="w-7 h-7 text-muted-foreground" />
        )}
      </div>
      <div className="space-y-2">
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`${testid}-input`} />
        <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()} className="border-border" data-testid={`${testid}-button`}>
          <ImagePlus className="w-4 h-4 mr-2" /> {value ? "Changer la photo" : "Ajouter une photo"}
        </Button>
        {value && (
          <Button type="button" variant="ghost" size="sm" onClick={() => onChange(null)} className="text-red-600 dark:text-red-400 block" data-testid={`${testid}-remove`}>
            <X className="w-4 h-4 mr-1 inline" /> Retirer
          </Button>
        )}
        <p className="text-xs text-muted-foreground">JPG, PNG ou WEBP — 5 Mo max</p>
      </div>
    </div>
  );
}
